module.exports = __webpack_public_path__ + "static/media/logo-header-mobile.441704d4.png";